import { useI18n } from '../../i18n'

const STYLES: Record<string, string> = {
  DRAFT: 'bg-gray-100 text-gray-700 border-gray-200',
  ACTIVE: 'bg-green-50 text-green-800 border-green-200',
  IN_REVIEW: 'bg-amber-50 text-amber-800 border-amber-200',
  DEPRECATED: 'bg-orange-50 text-orange-800 border-orange-200',
  ARCHIVED: 'bg-slate-100 text-slate-600 border-slate-300',
}

export default function LifecycleBadge({ status }: { status: string | null | undefined }) {
  const { t } = useI18n()
  const key = String(status || '').trim().toUpperCase()
  if (!key) {
    return (
      <span className="inline-flex text-xs px-2 py-0.5 rounded border border-gray-200 text-gray-400 italic">
        {t('common.unknown', 'Unknown')}
      </span>
    )
  }
  const style = STYLES[key] || 'bg-gray-50 text-gray-700 border-gray-200'
  return (
    <span className={`inline-flex text-xs font-medium px-2 py-0.5 rounded border ${style}`}>
      {t(`assets.lifecycle.${key}`, key)}
    </span>
  )
}
